import React from 'react';
import './App.css';
import TimeCalc from "./time-calc";

function App() {
  return (
    <div className="App">
        <h1> Time Difference Calculator </h1>
      <TimeCalc/>
    </div>
  );
}

export default App;
